// extracted by mini-css-extract-plugin
export var borderTop = "_s-3";
export var linkIcon = "_s-5";
export var linkIconSm = "_s-6";
export var linkOutCard = "_s-7 _s-4";
export var linkRow = "_s-2";
export var pageContainer = "_s-1";
export var providerIcon = "_s-8";
export var roundedBorder = "_s-4";
export var settingsContent = "_s-0";